var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinnersTopWaveMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 390 53"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M0 0c86.667 46.375 303.333-13.25 390 26.5V53H0z"
})));
export default SvgWinnersTopWaveMobile;